export default function () {

	if ( document.querySelector( '.js-personCard' ) ) {

		const parent = document.querySelectorAll( '.js-personCard' );

		parent.forEach( function ( element ) {

			const open = element.querySelector( '.js-personCard_open' );
			const close = element.querySelector( '.js-personCard_close' );
			const card = element.querySelector( '.js-personCard_card' );

			/**
			 *
			 */
			open.onclick = function () {

				card.classList.add( 'open' );

			}

			/**
			 *
			 */
			close.onclick = function () {

				card.classList.remove( 'open' );

			}

		} );

	}

}
